import React, { Component } from "react";
import _ from "lodash";
import { Grid, Paper, Typography } from "@material-ui/core";
import { WithStyles, createStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { QuestionBenchmarks } from "../../../types/Benchmarks";
import { getTime, getTimeUnit } from "../../../../../utils/getOffset.utils";

const styles = (theme: Theme) =>
  createStyles({
    keyValueContainer: {
      "& *": {
        display: "inline",
        marginRight: "4px",
      },
      marginTop: theme.spacing.unit * 2,
    },

    overviewMeta: {
      opacity: 0.6,
    },

    metaInfoBox: {
      marginTop: theme.spacing.unit,
      background: "#FDFDFD",
    },

    metaInfoBoxTable: {
      border: 0,
    },

    paddingSM: {
      padding: 16,
    },

    titleDesc: {
      marginTop: theme.spacing.unit * 2,
      "& p": {
        margin: 0,
      },
      "& p > img, img": {
        maxWidth: "100%",
      },
    },

    optionText: {
      display: "flex",
      whiteSpace: "nowrap",
      margin: "4px 0px",
      lineHeight: "38px",
      "& > span > p": {
        display: "inline",
        marginLeft: theme.spacing.unit,
      },
    },

    tagsList: {
      display: "inline-block",
      verticalAlign: "middle",
      marginRight: theme.spacing.unit,
      "&:after": {
        content: '"|"',
        marginLeft: theme.spacing.unit,
      },
      "&:last-child": {
        marginRight: 0,
        "&:after": {
          display: "none",
        },
      },
    },

    wrapText: {
      clear: "both",
      width: "100%",
      display: "inline-block",
      maxWidth: "96%",
      overflowX: "auto",
      whiteSpace: "initial",
      overflowY: "hidden",
      "& p": {
        margin: "0px",
        textAlign: "justify",
      },
    },

    widthSet: {
      width: "100%",
      "& .MyPATExpansionPanel-greyBackground-452": {
        backgroundColor: "#fff",
        background: "#fff !important",
      },
    },

    fontSM: {
      fontWeight: 600,
      fontSize: "1rem",
      lineHeight: "22px",
      color: "#333333",
    },

    fontXS: {
      fontWeight: 600,
      fontSize: "0.8rem",
      color: "#333",
    },

    blueColor: {
      color: "#1D7DEA",
    },

    greyColor: {
      color: "#333333",
    },
    imgContainer:{
      "& img": {
        width: "100%",
        height: "100%",
        objectFit: "contain"
      },
    },
    inlineChildren: {
      "& > *": {
        display: "inline-block",
        margin: "0"
      },
      "& > h4": {
        fontWeight: "normal"
      }
    }
  });

//@ts-ignore
interface TheoryPreviewProps extends WithStyles<typeof styles> {
  classes: any;
  content: any;
  questionBenchmarks: QuestionBenchmarks;
}

interface TheoryPreviewStates { }

class TheoryPreview extends Component<TheoryPreviewProps, TheoryPreviewStates> {
  constructor(props: TheoryPreviewProps) {
    super(props);

    this.getConceptsTagged = this.getConceptsTagged.bind(this);
    this.getSolutionContent = this.getSolutionContent.bind(this);
  }

  getConceptsTagged() {
    const { content, classes } = this.props;

    return _.reduce(
      _.get(content, "content.metaData.question.id.content[0].subjects", []),
      (acc: JSX.Element[], s) => {
        s.chapters.forEach((c: any) => {
          c.concepts.forEach((cc: any) => {
            let conceptName = _.get(cc, "conceptId.name");
            let conceptCode = _.get(cc, "conceptCode");
            if (conceptName) {
              acc.push(
                <Typography variant="body1">
                  {conceptName}{" "}
                  {conceptCode && (
                    <Typography variant="h6" inline className={classes.fontXS}>
                      (ID: {conceptCode})
                    </Typography>
                  )}
                </Typography>
              );
            }
          });
        });
        return acc;
      },
      []
    );
  }

  getSolutionContent(solutionContent: any) {
    return solutionContent === ("<p> <br></p>" || "")
      ? "Not Available"
      : solutionContent;
  }

  renderTolerance(value: any) {
    if (value || value == 0) {
      return value;
    }
    return "Not Defined";
  }

  getIdealTime(time: number) {
    return `${getTime(time)} ${getTimeUnit(time)}`
  }

  render() {
    const { classes, content, questionBenchmarks } = this.props;
    const subHeading = (_.get(
      content,
      "metaData.theory.subHeading",
      ""
    ) || '').trim() || "Not Available";
    return (
      <Grid container spacing={16} direction="column">
        <Grid item className={classes.widthSet}>
          <Paper className={classes.paddingSM}>
            <div><h3>Page {content.pageNumber}</h3></div>
            <div className={classes.inlineChildren}>
              <h4>Sub Heading</h4>:&nbsp;<div className={classes.metaInfoBox}>
                <Typography variant="body1">
                  <span dangerouslySetInnerHTML={{__html: subHeading,}} className={classes.imgContainer}/>
                </Typography>
              </div>
            </div>
            <div className={classes.metaInfoBox}>
            <Typography variant="body1">
                <span
                  dangerouslySetInnerHTML={{
                    __html: _.get(
                      content,
                      "metaData.theory.content",
                      "-"
                    ),
                  }}
                  className={classes.imgContainer}
                />
              </Typography>
            </div>
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(TheoryPreview);